import { takeEvery, getContext, call, put, select } from 'redux-saga/effects';
import actions, { LOAD_META_DATA_DESCRIPTOR, LOAD_META_ATTRIBUTES } from './actions';
import { getLogger } from '../../logger/index';
import { getSchemaDescriptors } from './selectors';
import { getLocale } from '../intl/selectors';

const logger = getLogger('schema');

function* loadMetadataSaga({ payload: { metaId } }) {
  try {
    const descriptors = yield select(getSchemaDescriptors);
    if (!descriptors[metaId] || (descriptors[metaId].pending && descriptors[metaId].data == null)) {
      const locale = yield select(getLocale);
      const http = yield getContext('http');
      const url = `/api/entitymetadatas/${metaId}.json?_locale=${locale}`;
      logger.debug('Fetch entity data on metaId', metaId, 'with URL', url);
      const response = yield call(http.get, url);
      logger.debug('Got response for entity data on metaId', metaId, '- Response', response);
      if (response.status < 200 || response.status > 299) {
        logger.error('Response with HTTP status', response.status, response);
        yield put(actions.loadMetadataFailure(response.data));
      } else {
        yield put(actions.loadMetadataComplete(response.data));
      }
    } else {
      yield put(actions.loadMetadataCancelled({ metaId }));
    }
  } catch (error) {
    logger.error('Exception occurred while fetching meta data descriptor on metaId', metaId, '- Error', error);
    yield put(actions.loadMetadataFailure({ metaId, error }));
  }
}

function* loadAttributesSaga({ payload: { category } }) {
  try {
    const locale = yield select(getLocale);
    const http = yield getContext('http');
    const url = `/api/attributes.json?filters%5Bcategories%5D=${category}&offset=0&limit=200&_locale=${locale}`;
    logger.debug('Fetch attributes on category', category, 'with URL', url);
    const response = yield call(http.get, url);
    logger.debug('Got response for attributes on category', category, '- Response', response);
    if (response.status < 200 || response.status > 299) {
      logger.error('Response with HTTP status', response.status, response);
      yield put(actions.loadAttributesFailure({ category, error: response.data }));
    } else {
      yield put(actions.loadAttributesComplete({ ...response.data, category }));
    }
  } catch (error) {
    logger.error('Exception occurred while fetching meta attributes on category', category, '- Error', error);
    yield put(actions.loadAttributesFailure({ category, error }));
  }
}

function* watchSchemaActions() {
  yield takeEvery(LOAD_META_DATA_DESCRIPTOR, loadMetadataSaga);
  yield takeEvery(LOAD_META_ATTRIBUTES, loadAttributesSaga);
}
export default watchSchemaActions;
